import React from 'react';
import { createUseStyles } from 'react-jss';
import { Colors, Theme } from '@app/theme';
import classnames from 'classnames';
import { Styles } from 'jss';
import mapValues from 'lodash/mapValues';

const useStyles = createUseStyles((theme: Theme) => ({
  globalContainer: {
    display: 'inline-flex',
    lineHeight: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.borderRadius.std,
    gap: theme.marginBase,
    padding: [theme.marginBase / 2, theme.marginBase],
    width: 'fit-content',
    backgroundColor: theme.colors.greenMuted,
  },
  noText: {
    padding: theme.marginBase / 2,
  },
  icon: {
    fontSize: theme.iconSize.small,
  },
  text: {
    lineHeight: '100%',
    alignSelf: 'normal',
  },
}));

const useColorsStyle = createUseStyles((theme: Theme): Styles<Colors> => {
  return mapValues(theme.colorDefinitions, (def) => ({
    backgroundColor: def.muted,
    '&  i': {
      color: def.accessible,
    },
    '&  p': {
      ...theme.fonts.label,
      color: def.accessible,
      lineHeight: '100%',
    },
    '& p:first-letter': {
      textTransform: 'capitalize',
    },
  }));
});

const usePlainColorStyle = createUseStyles((theme: Theme): Styles<Colors> => {
  return mapValues(theme.colorDefinitions, (def) => ({
    backgroundColor: def.accessible,
    '&  i': {
      color: theme.colors.white,
    },
    '&  p': {
      ...theme.fonts.label,
      color: theme.colors.white,
      paddingLeft: theme.marginBase,
      lineHeight: '100%',
    },
    '& p:first-letter': {
      textTransform: 'capitalize',
    },
  }));
});

interface Props {
  icon?: string;
  color: Colors;
  logoTitle?: string;
  text?: string;
  variant?: 'plain' | 'std';
}

export const IconsText = ({
  icon,
  text,
  color,
  variant = 'std',
  logoTitle,
}: Props) => {
  const classes = useStyles();
  const colorClasses = useColorsStyle();
  const plainStyles = usePlainColorStyle();

  return (
    <div
      className={classnames(classes.globalContainer, {
        [classes.noText]: icon && !text,
        [colorClasses[color]]: variant === 'std',
        [plainStyles[color]]: variant === 'plain',
      })}
    >
      {icon && (
        <i className={classnames(icon, classes.icon)} title={logoTitle} />
      )}
      {text && <p>{text}</p>}
    </div>
  );
};
